// FB TRACKING FOR CONTENT PAGE - JUNE 2017 APL 
// Next line commented out on June 26, 2018 to fix js console error - "fbq is not defined"
// fbq('track', 'ViewContent');
/////

(function($){
    $(document).ready(function(){
      
      if($('.custom-label-maker').length < 1) return; // boomerang page only
      
      // Sometimes you just want pretty thousands
      $('.thousands').each(function(){ 
        var curr_val = $(this).html();
        $(this).html(parseFloat(curr_val).toLocaleString());
      });
      
      // Whittle down the choices when a label substrate and shape is chosen  
      $('.custom-step-1 .chooser a').click(function(){
        var selected_type = $(this).attr('class').replace('_', '-'); // eg paper oval
        
        $('.custom-step-1 .chooser p').removeClass('selected');
        $(this).parent().addClass('selected').delay(500).queue(function(next){
          $(this).closest('.custom-step-1').hide().next().fadeIn();
          
          $('.custom-step-2 .custom-product-opts').hide();
          $('.custom-step-2 .custom-product-opts.'+selected_type).show(); // Show Paper Circle, etc
          $('.custom-step-2 .choose-size:visible').find('input').eq(0).click().trigger('change'); // Click first size box      
          next();
        });
        
        // Pop a little anchor onto the URL so that we can keep them from backing out of this page accidentally
        var new_url = window.location.protocol + "//" + window.location.host + window.location.pathname + '#start';
        window.history.pushState({path:new_url}, 'This is my title', new_url);
      });
  
      // Open the options when a size is chosen
      $('.custom-step-2 .choose-size input').change(function(){
        var chosen_id = $(this).parent().find('input:checked').val();
        
        $(this).closest('.chooser').find('.choose-qty .price-qty').hide().each(function(){
          if($(this).data('id') == chosen_id) $(this).show();
        });
      });
  
      // Set cookie when a quantity is chosen
      $('.custom-step-2 .choose-qty input').change(function(){
        var chosen_qty = $(this).parent().find('input:checked').val();
        var handle = $(this).data('handle');
        
        document.cookie = "chroma_custom_item_"+handle+"_qty="+chosen_qty+"; path=/";
        
        $(this).closest('.chooser').find('button.start-designing').prop('disabled', false);
      }); 
  
          // Go to Qstomizer
      $('button.start-designing').click(function(e){
        if($(this).prop('disabled') == true) return;
        
        var curr_prod_id    = $('.custom-step-2 .choose-size input:checked').val();
      
        var qstomizer_ids = {
          
          // Product id   // Qstomizer ID - these really need to be tied onto the correct products too
          503868391439:   13752, // 3/4" Paper Round
          1293318488132:  13795, // 3/4" Kraft Round
          1293320880196:	23675, // 3/4" Clear Round
          1292505940036:  13804, // 1" Paper Round
          1293320683588:	23672, // 1" Kraft Round
          1293321109572:	23676, // 1" Clear Round
          1292508168260:  16166, // 2" Paper Round
          1293320716356:	23673, // 2" Kraft Round
          1293321142340:	23677, // 2" Clear Round
          1293681360964:  16170, // 3" Paper Round
          1300042678340:	23674, // 3" Kraft Round
          1304782995524:	23678, // 3" Clear Round
          
          1293284638788:  16268, // 2.75" Paper Square
          1293317832772:  23680, // 2.75" Kraft Square
          1293321338948:	23681, // 2.75" Clear Square
          1435168997479:  27268, // 1x3" Paper Square
          1293682638916:  15703, // 2x3" Paper Square
          1293682802756:  15706, // 2x3" Kraft Square
          1300045201476: 	23679, // 2x3" Clear Square
          1293310820420:  16270, // 4" Paper Square
          1293317931076: 	24713, // 4" Kraft Square
          1293321404484:	24714, // 4" Clear Square 
          1293317406788:  16271, // 6" Paper Square
          1293317963844:	24716, // 6" Kraft Square 
          1293321470020: 	24715, // 6" Clear Square 
          
          1293300432964:	24717, // 1x2 Paper Oval 
          1293318127684:	24718, // 1x2 Kraft Oval   
          1293321306180:	24719 // 1x2 Clear Oval
        };
        
        if(qstomizer_ids[curr_prod_id] != 'undefined' && qstomizer_ids[curr_prod_id] > 1) {
          var q_url = 'https://'+window.location.hostname+'/apps/boomerang/?product='+qstomizer_ids[curr_prod_id];
          
          window.location.href = q_url;
          return;
        }
        
        alert('This product is still being configured. Usually you would now be directed to the Boomerang Customizer.');
        
      });
      
      // Handle the Start Over function and also in case the user uses the back button to do it
      $(window).on('click', '.start-over', function(){
        $('.custom-step-1').fadeIn().next().hide();
      });
          
          $(window).on('popstate', function(){ $('.start-over').click(); });
  
      // Document ready setup
      $('ol.custom-label-steps li.current').each(function(){ $(this).append('<em class="und"></em>'); } ); // underline el
      $('button.start-designing').after('<span class="start-over">Start Over</span>');
    });
  })(jQuery);
  